import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';

// Environment variables - use import.meta.env for Vite
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAKtFiXhITRTGPbDEXjBRzRjZNiSwyiqig',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'tufirma.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'tufirma',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'tufirma.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '902143516029',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:902143516029:web:7a46c56cb2d544dc478014',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-SFSTB0719H',
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app, 'dbtufirmapro');
const auth = getAuth(app);
const storage = getStorage(app);

// Conditionally initialize messaging (may not be supported in some browsers/environments)
let messaging: ReturnType<typeof getMessaging> | null = null;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
});

export { app, auth, db, messaging, storage };
